'use client';

import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import type { EpisodeData } from '../../services/api/goApi';
import type { ReadingProgressItem } from '../../services/api/progressApi';
import type { StoryTrackingData } from '../../services/tracking/storyEvent';
import { FloatingChapterButton } from './FloatingChapterButton';

const ReaderSidebar = dynamic(
  () => import('../../modules/reader/ReaderSidebar').then((m) => ({ default: m.ReaderSidebar })),
  { ssr: false },
);

interface FloatingChapterSidebarProps {
  storyTitle: string;
  urlSlug?: string | null;
  storyAuthor: string;
  storyId: string;
  episodes: EpisodeData[];
  currentEpisodeId?: number;
  locale: string;
  progress?: ReadingProgressItem | null;
  freeEpisodesCount?: number;
  show?: boolean;
  className?: string;
  isSubscribed?: boolean;
  publisher?: StoryTrackingData['publisher'];
}

export const FloatingChapterSidebar: React.FC<FloatingChapterSidebarProps> = ({
  storyTitle,
  urlSlug,
  storyAuthor,
  storyId,
  episodes,
  currentEpisodeId,
  locale,
  progress,
  freeEpisodesCount = 0,
  show = true,
  className,
  isSubscribed = false,
  publisher,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isOpened, setIsOpened] = useState(false);

  const handleButtonClick = () => {
    setIsOpened(true);
    setIsSidebarOpen(true);
  };

  const handleSidebarClose = (open: boolean) => {
    setIsSidebarOpen(open);
  };

  if (!episodes || episodes.length === 0) {
    return null;
  }

  return (
    <>
      <FloatingChapterButton onClick={handleButtonClick} show={show} className={className} />
      {isOpened && (
        <ReaderSidebar
          mode="web"
          renderTrigger={false}
          isOpen={isSidebarOpen}
          onOpenChange={handleSidebarClose}
          storyTitle={storyTitle}
          urlSlug={urlSlug}
          storyAuthor={storyAuthor}
          storyId={storyId}
          episodes={episodes}
          currentEpisodeId={currentEpisodeId}
          locale={locale}
          progress={progress}
          freeEpisodesCount={freeEpisodesCount}
          isSubscribed={isSubscribed}
          publisher={publisher}
        />
      )}
    </>
  );
};
